<template>
  <SelectInput
    name="Award"
    label=""
    :options="awards?.map((a) => ({ label: a.name, value: a.id })) ?? []"
    v-model="selectedAwardId"
    @change="($event: any) => onChange($event.target.value)"
  />
</template>

<script setup lang="ts">
import { ref, watch } from "vue";
import { SelectInput } from "@/components/inputs";
import useAwards from "@/composables/use-awards";

const { awards, activeAward } = useAwards();

const selectedAwardId = ref<string>(activeAward.value?.id ?? "");
watch(activeAward, (award) => {
  if (award) {
    selectedAwardId.value = award?.id;
  }
});

function onChange(id: string) {
  const award = awards.value?.find((a) => a.id === id);
  if (award) {
    window.location.replace(`${award.settings?.appUrl}/dashboard`);
  }
}
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.8s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
.award-list ul li {
  cursor: pointer;
}
</style>
